import { TopBar } from "../../features/top/TopBar";
import { selectUser } from "../../redux/user/userSlice";
import { useSelector } from "react-redux";
import { retrieveSchools } from "../../redux/school/schoolsSlice";
import { useAppDispatch } from "../../app/hooks";
import PageAuthenticatedLoading from "../../features/pages/PageAuthenticatedLoading";
import { ContextMenu, ContextMenuOptions } from "../../features/base/ContextMenu";
import MenuIcon from "@mui/icons-material/Menu";
import { Typography } from "@mui/material";
import { AllConversation } from "./AllConversation";

export function Conversations() {
    const user = useSelector(selectUser);
    const dispatch = useAppDispatch();

    const options: ContextMenuOptions[] = [];
    const topMenu = <ContextMenu label={<MenuIcon />} options={options} />;

    return <PageAuthenticatedLoading
        topbar={<TopBar 
            topMenu={topMenu}
            title={<Typography variant="h6" component="div">Conversas</Typography>}
            />}
        loading={{
            states: [],
            content: () => { return <AllConversation />; },
            error: "Erro ao carregar conversas",
            retry: () => dispatch(retrieveSchools({}))
        }} />;
}
